import { Component, OnInit } from '@angular/core';


export interface Package {
  name: string;
  duration: string;
  price: string;
  image:string;
}

@Component({
  selector: 'app-sponsorevent',
  templateUrl: './sponsorevent.component.html',
  styleUrls: ['./sponsorevent.component.scss']
})
export class SponsoreventComponent implements OnInit {


  public packages: Package[] = [
    {name: 'Standard Package', duration: '5 days', price: '20$',image:'https://www.pngkey.com/png/full/395-3956035_credit-card-image-best-price-ico-icon.png' },
    {name: 'Advanced Package', duration: '10 days', price: '30$',image:'https://cdn2.iconfinder.com/data/icons/popular-badges-colored/48/JD-09-512.png' },
    {name: 'Premium Package', duration: '20 days', price: '40$',image:'https://gtel.net/wp-content/uploads/2017/05/best-value-icon-lg.png' },
  ];

  constructor() {}

  ngOnInit(): void {
  }

  highlightedPackage: Package = null;



}
